import type { InferRouterContractOutputs } from "@orpc/contract";
import { openapi } from "@orpc/openapi";
import { z } from "zod";
import { readContract } from "./errors";

export const typesSchema = z.object({
  items: z.array(z.object({ id: z.int(), title: z.string().nullable() })),
});
export const occupationsSchema = z.object({
  items: z.array(
    z.object({ id: z.int(), occupation: z.string(), title: z.string() }),
  ),
});
const labelSchema = z.object({ id: z.int(), label: z.string() });
export const settingsOptionsSchema = z.object({
  visitRetentionPeriods: z.array(
    z.object({ id: z.int(), label: z.string(), value: z.number() }),
  ),
  transcriptionLanguages: z.array(
    z.object({
      id: z.int(),
      name: z.string(),
      code: z.string().nullable(),
    }),
  ),
  styles: z.array(labelSchema),
  formats: z.array(labelSchema),
});
export const stripePublishableKeySchema = z
  .string()
  .regex(/^pk_(test|live)_[A-Za-z0-9]+$/)
  .refine((value) => value === value.trim());
export const appConfigSchema = z.object({
  stripePublishableKey: stripePublishableKeySchema.optional(),
  stripeTableId: z.string().optional(),
  stripePageUrl: z.string().optional(),
});

export const referenceContract = {
  types: readContract
    .meta(
      openapi({
        method: "GET",
        path: "/api/v2/types",
        successStatus: 200,
        spec: (spec) => ({ ...spec, security: [] }),
      }),
    )
    .output(typesSchema),
  occupations: readContract
    .meta(
      openapi({
        method: "GET",
        path: "/api/v2/occupations",
        successStatus: 200,
        spec: (spec) => ({ ...spec, security: [] }),
      }),
    )
    .output(occupationsSchema),
  settingsOptions: readContract
    .errors({
      UNAUTHORIZED: { message: "Authentication required" },
      FORBIDDEN: { message: "Account required" },
      SERVICE_UNAVAILABLE: { message: "Authentication unavailable" },
    })
    .meta(
      openapi({
        method: "GET",
        path: "/api/v2/settings/options",
        successStatus: 200,
        spec: (spec) => ({ ...spec, security: [{ bearerAuth: [] }] }),
      }),
    )
    .output(settingsOptionsSchema),
  appConfig: readContract
    .meta(
      openapi({
        method: "GET",
        path: "/api/v2/app-config",
        successStatus: 200,
        spec: (spec) => ({ ...spec, security: [] }),
      }),
    )
    .output(appConfigSchema),
};

export type ReferenceOutputs = InferRouterContractOutputs<
  typeof referenceContract
>;
